/**
 * Formats a whole-second count as `m:ss`, e.g. `formatTime(75)` → `"1:15"`.
 */
export const formatTime = (totalSeconds: number): string => {
  const m = Math.floor(totalSeconds / 60)
  const s = Math.floor(totalSeconds % 60)
  return `${m}:${s.toString().padStart(2, '0')}`
}
